import React from "react";
import LargeButton from "components/commons/Buttons/LargeButton";
import API from "services/api";
import { Wrapper } from "./styled";
import { useDispatch } from "react-redux";
import * as types from "store/Login/types";
import { BYPASS_LOGIN, PATH_SIGN_IN } from "components/pages/App/constants";
import { push } from "connected-react-router";

const Buttons = () => {
  const dispatch = useDispatch();

  const onSubmit = async () => {
    if (BYPASS_LOGIN) {
      try {
        const response = await API.login.getUser("");
        if (response.status == 200) {
          localStorage.setItem("user", JSON.stringify(response.data.result.user));
          dispatch({ type: types.LOGIN_SUCCESS, token: "", tokenExpires: "", user: response.data.result.user });
        } else dispatch({ type: types.LOGIN_FAILED, error: response?.statusText });
      } catch (error) {
        dispatch({ type: types.LOGIN_FAILED, error });
      }
    // } else window.keycloakSession.init({ onLoad: "login-required", checkLoginIframe: false });
    } else dispatch(push(PATH_SIGN_IN));
  };

  return (
    <Wrapper onClick={onSubmit}>
      <LargeButton label={"Iniciar sesión"} onClick={onSubmit} />
    </Wrapper>
  );
};

export default Buttons;
